/**
 * Admin business edit form — extend this object when adding new editable fields.
 * @typedef {Object} AdminBusinessEditFormValues
 * @property {string} googlePlaceId
 */

/** @returns {AdminBusinessEditFormValues} */
export function createAdminBusinessEditFormFromBusiness(business) {
  return {
    googlePlaceId: business?.GoogleReview?.PlaceId ?? '',
  };
}

/**
 * Builds a PATCH body from form values vs the current business record.
 * Only includes keys that changed.
 * @param {AdminBusinessEditFormValues} form
 * @param {object} business
 * @returns {Record<string, unknown>}
 */
export function buildAdminBusinessEditPatch(form, business) {
  const patch = {};

  const draftPlaceId = String(form.googlePlaceId ?? '').trim();
  const currentPlaceId = String(business?.GoogleReview?.PlaceId ?? '').trim();
  if (draftPlaceId !== currentPlaceId) {
    patch.GoogleReview = { PlaceId: draftPlaceId || null };
  }

  return patch;
}

/** @param {AdminBusinessEditFormValues} form @param {object} business */
export function isAdminBusinessEditUnchanged(form, business) {
  return Object.keys(buildAdminBusinessEditPatch(form, business)).length === 0;
}
